import { Template } from "../local"
import { ItemPreview } from "./item-preview"

class TemplatePreview {
  id: number | string
  title: string
  description: string
  revision: string
  template_id: string
  options: Record<string, any> = {}
  language: string
  items: ItemPreview[]
  global_items: TemplatePreview[]
  translations: []


  constructor(data: Partial<TemplatePreview>) {
    const {
      id = '',
      title = '',
      description = '',
      revision = '',
      template_id = '',
      options = {},
      language = '',
      translations = [],
      items = [],
      global_items = []
    } = data
    this.id = id
    this.title = title
    this.description = description
    this.revision = revision
    this.template_id = template_id
    this.options = options ?? {}
    this.language = language ?? ''
    this.translations = translations ?? []
    this.items = items.map(item => new ItemPreview(item))
    this.global_items = global_items.map(item => new TemplatePreview(item))
  }

  static fromProcessingPreviewData(template: any): TemplatePreview {
    return new TemplatePreview({
      id: template?.id,
      title: template?.title,
      description: template?.description,
      revision: template?.revision,
      template_id: template?.template_id,
      options: template?.options,
      language: template?.language,
      translations: template?.translations,
      items: template?.items.map((item: any) => ItemPreview.fromTemplatePreviewItem(item, template)) ?? [],
      global_items: template?.global_items.map((globalItem: any) => TemplatePreview.fromProcessingPreviewData(globalItem)) ?? []
    })
  }
}

export { TemplatePreview }